// This is an email convenience for the existing email-only build collection,
// not proof of identity for private Shopify customer data.
async function getShopifyCustomerEmail({ location = window.location, fetcher = window.fetch.bind(window), parse = html => new DOMParser().parseFromString(html, 'text/html') } = {}) {
  if (location.hostname !== 'www.velodrom.cc' && location.hostname !== 'velodrom.cc') return '';
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 5000);
  try {
    // Absolute storefront URL bypasses the builder's axios base URL and proxy.
    const url = new URL('/', location.origin);
    url.searchParams.set('section_id', 'bikebuilder-customer');
    url.searchParams.set('_', Date.now());
    const response = await fetcher(url.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
    if (!response.ok) return '';
    const element = parse(await response.text()).querySelector('#bikebuilder-customer-email');
    const email = element && element.content.textContent.trim().toLowerCase();
    return email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
  } catch { return ''; } // Guests, missing theme section and outages retain email entry.
  finally { clearTimeout(timer); }
}
module.exports = { getShopifyCustomerEmail };
